import {apiClient} from '../init.ts';
import {getHydraCollection, NormalizedCollectionResponse} from '@alchemy/api';
import {EntityName, OperationTask} from './types.ts';
import {PaginationParams} from '@alchemy/phrasea-framework';

export type GetTasksOptions = {
    query?: string;
    page?: number;
} & PaginationParams;

export async function getTasks({
    nextUrl,
    ...params
}: GetTasksOptions = {}): Promise<NormalizedCollectionResponse<OperationTask>> {
    const res = await apiClient.get(nextUrl ?? `/${EntityName.OperationTask}`, {
        params,
    });

    return getHydraCollection(res.data);
}

export async function getTask(id: string): Promise<OperationTask> {
    return (await apiClient.get(`/${EntityName.OperationTask}/${id}`)).data;
}

export async function postRunOperationTask(
    data: Partial<OperationTask>
): Promise<OperationTask> {
    const res = await apiClient.post(`/${EntityName.OperationTask}`, data);

    return res.data;
}
